// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table {
  font-size: 13px;
}
.table tbody tr {
  cursor: pointer;
}

.item-title {
  position: absolute;
  background: white;
  padding: 0.75rem;
}

table {
  display: flex;
  flex-flow: column;
  height: calc(100vh - 240px - 1rem);
  width: 100%;
  border-bottom: 1px solid #dee2e6;
}

table thead {
  flex: 0 0 auto;
  width: calc(100% - 0.9em);
}

table tbody {
  flex: 1 1 auto;
  display: block;
  overflow-y: scroll;
}

table tbody tr {
  width: 100%;
}

table thead, table tbody tr {
  display: table;
  table-layout: fixed;
}

tbody {
  overflow-y: auto;
  overflow-x: hidden;
}
tbody tr {
  cursor: pointer;
}
tbody tr:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  transition: all 200ms ease;
}

td {
  padding: 1.2rem 0.25rem;
  border-top: none;
  border-bottom: 1px solid #dee2e6;
}
td:first-child {
  padding-left: 2rem;
}

th {
  padding: 1rem 0.25rem;
}
th:first-child {
  padding-left: 2rem;
}

.table thead th {
  border-top: none;
  border-bottom: 1px solid #dee2e6;
}

.individuals-row {
  font-size: 12px;
}

.matches-list tbody tr td {
  text-align: left;
}

.home-team-container .title-name, .away-team-container .title-name {
  padding-left: 1rem;
}
.home-team-container img, .away-team-container img {
  display: inline-block;
}

.dropdown-container select.form-control {
  font-size: 1rem;
  padding: 0.4125rem 0.875rem;
}

.actions span {
  padding-right: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/matches-configuration/matches-list/matches-list.component.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;AACD;AACC;EACA,eAAA;AACD;;AAKA;EACC,kBAAA;EACG,iBAAA;EACA,gBAAA;AAFJ;;AAMA;EACC,aAAA;EACA,iBAAA;EACA,kCAAA;EACA,WAAA;EACA,gCAAA;AAHD;;AAKA;EACC,cAAA;EACA,yBAAA;AAFD;;AAIA;EACC,cAAA;EACA,cAAA;EACA,kBAAA;AADD;;AAGA;EACC,WAAA;AAAD;;AAGA;EACC,cAAA;EACA,mBAAA;AAAD;;AAEA;EACC,gBAAA;EACA,kBAAA;AACD;AAAC;EACC,eAAA;AAEF;AADE;EACC,uCAAA;EACA,0BAAA;AAGH;;AACA;EACC,uBAAA;EACA,gBAAA;EACA,gCAAA;AAED;AAAC;EACC,kBAAA;AAEF;;AACA;EACC,qBAAA;AAED;AADC;EACC,kBAAA;AAGF;;AAAA;EACC,gBAAA;EACA,gCAAA;AAGD;;AADA;EACC,eAAA;AAID;;AAEM;EACE,gBAAA;AACR;;AAME;EACE,kBAAA;AAHJ;AAME;EACE,qBAAA;AAJJ;;AASE;EACE,eAAA;EACA,2BAAA;AANJ;;AAWE;EACE,mBAAA;AARJ","sourcesContent":[".table{\n\tfont-size: 13px;\n\ttbody{\n\ttr{\n\tcursor: pointer;\n\n\t}\n}\n}\n\n.item-title{\n\tposition: absolute;\n    background: white;\n    padding: 0.75rem;\n}\n\n\ntable {\n\tdisplay: flex;\n\tflex-flow: column;\n\theight: calc(100vh - 240px - 1rem);\n\twidth: 100%;\n\tborder-bottom: 1px solid #dee2e6;\n}\ntable thead {\n\tflex: 0 0 auto;\n\twidth: calc(100% - 0.9em);\n}\ntable tbody {\n\tflex: 1 1 auto;\n\tdisplay: block;\n\toverflow-y: scroll;\n}\ntable tbody tr {\n\twidth: 100%;\n\n}\ntable thead, table tbody tr {\n\tdisplay: table;\n\ttable-layout: fixed;\n}\ntbody {\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\ttr {\n\t\tcursor: pointer;\n\t\t&:hover {\n\t\t\tbox-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n\t\t\ttransition: all 200ms ease;\n\t\t}\n\t}\n}\ntd {\n\tpadding: 1.2rem 0.25rem;\n\tborder-top: none;\n\tborder-bottom: 1px solid #dee2e6;\n\n\t&:first-child {\n\t\tpadding-left: 2rem;\n\t}\n}\nth {\n\tpadding: 1rem 0.25rem;\n\t&:first-child {\n\t\tpadding-left: 2rem;\n\t}\n}\n.table thead th {\n\tborder-top: none;\n\tborder-bottom: 1px solid #dee2e6;\n}\n.individuals-row {\n\tfont-size: 12px;\n}\n\n.matches-list {\n  tbody {\n    tr {\n      td {\n        text-align: left;\n      }\n    }\n  }\n}\n\n.home-team-container, .away-team-container {\n  .title-name {\n    padding-left: 1rem;\n  }\n\n  img {\n    display: inline-block;;\n  }\n}\n\n.dropdown-container {\n  select.form-control {\n    font-size: 1rem;\n    padding: 0.4125rem 0.875rem;\n  }\n}\n\n.actions {\n  span {\n    padding-right: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
